import React from "react";
import { CSSTransition } from "react-transition-group";
import "./AnimationContainer.scss";

const AnimationContainer = ({
  children,
  containerElementClassName = "",
  animationOn = true,
  animationClassName,
  timeout = 500,
  isUnmountOnExit = true,
}) => (
  <CSSTransition
    in={animationOn}
    timeout={timeout}
    classNames={animationClassName}
    unmountOnExit={isUnmountOnExit}
  >
    {containerElementClassName ? (
      <div className={containerElementClassName}>{children}</div>
    ) : (
      <>{children}</>
    )}
  </CSSTransition>
);

AnimationContainer.defaultProps = {
  animationOn: true,
  timeout: 500,
  isUnmountOnExit: true,
};

export default AnimationContainer;
